import { z } from "zod";
import { ConfigurationsTypeOutputSchema } from "@/Schemas/Configurations/ConfigurationsTypeOutput";
import { ConfigurationsStateOutputSchema } from "@/Schemas/Configurations/ConfigurationsStateOutput";
import { ConfigurationsProcessingOutputSchema } from "@/Schemas/Configurations/ConfigurationsProcessingOutput";
import { ConfigurationsSourceOutputSchema } from "@/Schemas/Configurations/ConfigurationsSourceOutput";
import { ConfigurationsRecordOutputSchema } from "./ConfigurationsRecordOutput";

export const ConfigurationsOutputSchema = z.object({
    type: ConfigurationsTypeOutputSchema,
    state: ConfigurationsStateOutputSchema,
    processing: ConfigurationsProcessingOutputSchema,
    source: ConfigurationsSourceOutputSchema,
    record: ConfigurationsRecordOutputSchema,
});

export type ConfigurationsOutput = z.infer<typeof ConfigurationsOutputSchema>;